import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { GeneralSettings } from 'app/profile/models/generic.model';
import { getGeneralSettings, SelectSupplierTaxList } from 'app/profile/store/app.selector';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { TabComponent } from '../tab-component';
import { TaxGridComponent } from './tax-grid/tax-grid.component';
import { GetSupplierTaxListByCode } from 'app/profile/store/app.actions';
import { isDataUnderReview } from 'app/shared/constants';

@Component({
  selector: 'app-tax',
  templateUrl: './tax.component.html',
  styleUrls: ['./tax.component.scss']
})
export class TaxComponent implements OnInit, TabComponent {
  settings: GeneralSettings;
  @Input() data: any;
  supplierCode: string;
  helpUrl: string;

  // Data Review Variables
  isDataUnderReview: boolean = false;

  @ViewChild('taxgrid') bankGrid: TaxGridComponent;

  constructor(private store: Store<SupplierState>,
    private activatedRoute: ActivatedRoute) { }

  isDirty(): boolean {
    return false;
  }

  ngOnInit() {
    this.store.select(getGeneralSettings).subscribe(res => {
      this.settings = res;
      if (res) {
        this.helpUrl = this.settings.settings.taxHelpUrl;
      }
    });
    this.activatedRoute.parent.params.subscribe(params => {
      this.supplierCode = params['code'];
      // Get Data
      this.store.dispatch(new GetSupplierTaxListByCode(this.supplierCode));
      this.store.select(SelectSupplierTaxList).subscribe(dataList => {
          this.isDataUnderReview = isDataUnderReview(dataList);
          console.log(this.isDataUnderReview);
      });
    });
  }

}
